import React from 'react'
import { DocWithPreview } from '../../Common/DocWithPreview'
import { Box,  Grid, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material'
import TextLabel from '../../Common/CommonTextLabel'
import { useLocation } from 'react-router';
import CommonTextField from '../../Common/CommonTextField';
import CommonTextArea from '../CommonTextArea';
import ButtonOutlined from '../../Common/ButtonOutlined';
import ButtonContained from '../../Common/ButtonContained';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { checkAccess } from '../../../Utils/handler';
import CommonDropDown from '../../Common/CommonDropDown';
import { additionalDocumentTypeList } from '../../../Utils/enum';
import ReUploadModal from '../../Common/ReUploadModal';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import sessionStoreUtil from '../../../ApiSetup/Localstorage';

const AdditionalDocument = ({ data, isEdit, setIsEdit, setData, handleStatusChange, handleInputChange, handleChange, errors, dataAccess, handleUpload, openAdditionalDocument, setOpenAdditionalDocument, }) => {
   
    const theme = useTheme()
    const { pathname } = useLocation()
    const startPathname = pathname?.split('-')[0];
    const user = sessionStoreUtil.getLSItem("userData")        ? JSON.parse(sessionStoreUtil.getLSItem("userData"))        : {};

    return (
        <Grid container item xs={12}>
            <Grid item sm={12} xs={12}>
                <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Additional Document"} secondText="(Optional)" secondTextColor={theme.palette.bgLightBlack.main} marginBottom={1} />
                <DocWithPreview
                    docArray={data?.uploadDocuments?.additionalDocument?.additionalDocumentFile?.length > 0 ? data?.uploadDocuments?.additionalDocument?.additionalDocumentFile : []}
                    docName={"Additional Document"}
                    title='Additional Document'
                />
                {((checkAccess(startPathname, dataAccess, 'Reupload Button')) && isEdit.additionalDocument) && <ButtonOutlined
                    startIcon={<CloudSyncOutlinedIcon />}
                    border={"none"}
                    width={"auto"}
                    text={"Reupload"}
                    padding={{ xs: "5px 10px", md: "5px 10px" }}
                    fontSize={{ xs: "12px", md: "14px" }}
                    height={{ xs: "30px", sm: "30px" }}
                    onClick={() => { setOpenAdditionalDocument(true) }}
                />}
            </Grid>

            <Grid container spacing={1} >
                <Grid item xs={12} sm={6}>
          
                    <CommonDropDown
                        notShowSelect
                        type="text"
                        text={'Additional Document Type'}
                        name={'additionalDocumentType'}
                        value={data?.uploadDocuments?.additionalDocument?.additionalDocumentType || ""}
                        values={additionalDocumentTypeList?.map((e) => e?.label) || []}
                        placeholder={`Select additional document type`}
                        width={"100%"}
                        valid
                        onChange={(e) => {
                            const { value, name } = e?.target
                            setData(prevData => ({
                                ...prevData,
                                uploadDocuments: {
                                    ...prevData.uploadDocuments,
                                    ['additionalDocument']: {
                                        ...(prevData.uploadDocuments['additionalDocument'] || {}),  // ensure that the section exists
                                        [name]: value?.trimStart(),  // Update only the specified field
                                    }
                                }
                            }));
                        }}
                        disabled={!isEdit.additionalDocument}
                    />
                    {/* <TextLabel color="error" title={!data?.uploadDocuments?.additionalDocument?.cast ? errors?.cast : ""} /> */}
                </Grid>
              
                <Grid item xs={12}>
                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={1}>
                        {checkAccess(startPathname, dataAccess, 'Edit Action') &&
                            <ButtonContained
                                backgroundColor={!isEdit.additionalDocument ? theme.palette.primary.main : theme.palette.success.main}
                                width={"auto"}
                                text={isEdit.additionalDocument ? "Save" : "Edit"}
                                borderRadius={'20px'}
                                padding={{ xs: "5px 10px", md: "5px 10px" }}
                                fontSize={{ xs: "12px", md: "14px" }}
                                height={{ xs: "30px", sm: "30px" }}
                                onClick={() => { setIsEdit({ additionalDocument: !isEdit?.additionalDocument }) }}
                            />
                        }
                        {checkAccess(startPathname, dataAccess, 'Accept/Reject Action') && data?.verificationStatus !== "Approved" &&
                            <Box display={'flex'} alignItems={'center'} gap={1}>
                                <ToggleButtonGroup
                                    color={data?.additionalDocument?.status == "Approved" ? "success" : "error"}
                                    value={data?.additionalDocument?.status}
                                    exclusive
                                    aria-label="Platform"
                                    size='small'
                                >
                                    <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Approved" onClick={() => handleStatusChange("status", "additionalDocument", "Approved")}>
                                        {data?.additionalDocument?.status == "Approved" ? "Approved" : "Approve"}</ToggleButton>
                                    <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Rejected" onClick={() => handleStatusChange("status", "additionalDocument", "Rejected")}>
                                        {data?.additionalDocument?.status == "Rejected" ? "Rejected" : "Reject"}</ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        }
                        {
                            checkAccess(startPathname, dataAccess, 'Accept/Reject Action') &&
                            data?.verificationStatus == "Approved" && <ButtonOutlined
                                width={"auto"}
                                text={"Approved"}
                                border={"1px dashed green"}
                                color={'green'}
                                borderRadius={'20px'}
                                padding={{ xs: "5px 10px", md: "5px 10px" }}
                                fontSize={{ xs: "12px", md: "14px" }}
                                height={{ xs: "30px", sm: "30px", md: "30px" }}
                                endIcon={<CheckCircleIcon />}
                            />}
                    </Box>
                </Grid>

                {data?.verificationStatus !== "Approved" && data?.additionalDocument?.status == "Rejected" && <Grid item xs={12}>
                    <CommonTextArea
                        label="Reason"
                        value={data?.additionalDocument?.reason}
                        labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                        name='reason'
                        onChange={(e) => handleInputChange(e, "additionalDocument")}
                        rows={2}
                        disabled={user?.organisationName !== "PPSK"}
                    />
                </Grid>}

                {/* <Grid item xs={12} display={"flex"} justifyContent={"flex-end"} gap={1}>
                    <ButtonOutlined
                        width={"auto"}
                        text={"Cancel"}
                        color={"#3E4094"}
                        lineHeight={"24.5px"}
                        backgroundColor={"#fff"}
                        border={"1px solid #3E4094"}
                        padding={{ xs: "5px 10px", md: "10px 20px" }}
                        fontSize={{ xs: "12px", md: "14px" }}
                        height={{ xs: "40px", sm: "40px" }}
                        onClick={() => navigate("/documents")}
                    />

                    <ButtonContained
                        width={"auto"}
                        text={"Confirm"}
                        lineHeight={"24.5px"}
                        padding={{ xs: "5px 10px", md: "10px 20px" }}
                        fontSize={{ xs: "12px", md: "14px" }}
                        height={{ xs: "40px", sm: "40px" }}
                        onClick={() => data?.verificationStatus === "Approved" ? setValue("4") : _updateMember("4")}
                    />
                </Grid> */}
            </Grid>


            {openAdditionalDocument &&
                <ReUploadModal
                    multiple
                    open={openAdditionalDocument}
                    handleClose={() => setOpenAdditionalDocument(false)}
                    onSave={() => setOpenAdditionalDocument(false)}
                    text={"Additional Document (અન્ય પુરાવા)"}
                    name={"image"}
                    onChange={(e) => handleUpload(e, "uploadDocuments", "additionalDocument")}
                    imageValue={data?.uploadDocuments?.additionalDocument?.additionalDocumentFile}
                />}

        </Grid>
    )
}

export default AdditionalDocument
